import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Skeleton from '@material-ui/lab/Skeleton';
import { avatarMeasures, iconSizes } from 'UI/constants/dimensions';
import { getAvatarColor } from 'UI/utils';

import { avatarDefinitions } from './definitions';
import { AvatarUserColors, defaulAvatarClasses } from './styles';

/**
 * Custom avatar component with badge support and user color generation
 * @param {Object} props
 * @param {Object|null} [props.badgeProps=null] - Props passed to Material-UI Badge component
 * @param {React.ReactNode} [props.children='N/A'] - Content rendered inside avatar when mode is 'user'
 * @param {boolean} [props.loading=false] - When true, renders a skeleton loader instead of avatar
 * @param {string} [props.mode='user'] - Avatar mode: 'candidate', 'company', 'hiringAuthority', 'user', or 'default'
 * @param {string} [props.size='medium'] - Avatar size: 'small', 'medium', or 'large'
 * @param {string} [props.userEmail=''] - User email for deterministic color generation
 */
const FPAvatar = ({
  badgeProps = null,
  children = 'N/A',
  loading = false,
  mode = 'user',
  size = 'medium',
  userEmail = '',
  ...rest
}) => {
  const avatarIconMeasures = {
    small: 'sm',
    medium: 'md',
    large: 'lg'
  };

  const skeletonWidth = avatarMeasures[size];
  const avatarColor = getAvatarColor(userEmail);
  const userColorValue = AvatarUserColors[avatarColor];
  const userMode = mode === avatarDefinitions.types.user;
  const avatarIconSize = iconSizes.streamline[avatarIconMeasures[size]];

  const defaultModeClasses = defaulAvatarClasses({ mode })();

  const avatarItem = (
    <Avatar
      classes={{
        root: `avatar-${size}`,
        colorDefault: userMode ? `avatar-${userColorValue}` : defaultModeClasses.colorDefault
      }}
      {...rest}
    >
      {userMode ? children ?? 'N/A' : avatarDefinitions.icons[mode](avatarIconSize)}
    </Avatar>
  );

  const avatarWithBadge = badgeProps ? <Badge {...badgeProps}>{avatarItem} </Badge> : avatarItem;

  return loading ? (
    <Skeleton variant="circle" width={skeletonWidth} height={skeletonWidth} />
  ) : (
    avatarWithBadge
  );
};

export default FPAvatar;
